import styled from 'styled-components'

export const UploadCustomersButtonWrapper = styled.div`
	margin-right: 15px;
`
